import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { colors } from "../../themeReact"

const useStyles = makeStyles((theme) => ({
  root: {
    lineHeight: 2,
    fontWeight: 400,
    fontSize: 16,
    textDecoration: "none",
    color: theme.palette.common.white,
    "&:hover": {
      color: theme.palette.secondary.main,
      textDecoration: "none",
    },
  },
  svgL: {
    verticalAlign: -2,
    display: "inline-block",
    marginLeft: 5,
    color: colors.subtle,
  },
}))

const ExternalFooterLink = ({ children, href, target, rel }) => {
  const classes = useStyles()
  return (
    <a className={classes.root} href={href} target={target} rel={rel}>
      {children}
      <svg
        x="0px"
        y="0px"
        viewBox="0 0 100 100"
        width={15}
        height={15}
        className={classes.svgL}
      >
        <path
          fill="currentColor"
          d={`
          M18.8,85.1h56l0,0c2.2,0,4-1.8,4-4v-32h-8v28h-48v-48h28v-8h-32l0,
          0c-2.2,0-4,1.8-4,4v56C14.8,83.3,16.6,85.1,18.8,85.1z
        `}
        />
        <polygon
          fill="currentColor"
          points={`
          45.7,48.7 51.3,54.3 77.2,28.5 77.2,37.2 85.2,37.2 85.2,14.9 62.8,
          14.9 62.8,22.9 71.5,22.9
          `}
        />
      </svg>
    </a>
  )
}

export default ExternalFooterLink
